import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TestimonialSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // For screens <= 1024px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // For screens <= 768px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const testimonials = [
    {
      message:
        "TSE is unlike anything I’ve seen. It doesn’t just track markets—it reshapes them. As an investor, this platform turned geopolitical noise into real alpha. Pure brilliance.",
      name: "Alexander V.",
      role: "Global Macro Investor | Switzerland",
    },
    {
      message:
        "As a supply chain strategist, TSE’s dashboards and policy prediction models gave me the foresight I needed. We averted millions in losses by staying ahead of tariff disruptions.",
      name: "Mei Lin",
      role: "Director of Logistics, Manufacturing Conglomerate | Singapore",
    },
    {
      message:
        "Tariff Coin is the most innovative utility token I’ve used. It’s not just about trading—it powers intelligence, access, and governance. I’m all in on the Tariff Economy.",
      name: "Ibrahim K.",
      role: "Blockchain Developer & Web3 Consultant | UAE",
    },
    {
      message:
        "TSE's approach to economic conflict is genius. They’ve created tools that allow small nations and startups to play the big policy game. This is fintech with a spine.",
      name: "Kwame A.",
      role: "Policy Analyst | Ghana Trade Ministry",
    },
    {
      message:
        "The moment I saw the microprocessor tech and predictive models in action, I knew TSE was building the future. It’s not fintech—it’s financial warfare reimagined.",
      name: "Dr. Leena M.",
      role: "AI Researcher & Trade Economist | India",
    },
    {
      message:
        "TSE gave me more than data. It gave me clarity. I’ve repositioned my entire export business based on its insights—and we’re now seeing record growth.",
      name: "Carlos H.",
      role: "Founder, AgroExports Ltd. | Brazil",
    },
  ];
  
  return (
    <>
      <div className="container-fluid p-0 m-0 overflow-hidden">
        <div className="row g-0">
          <h2 className="text-center text-accent-blue font-aeonik text-3xl font-bold mb-10">
            What Clients Say
          </h2>
          <div className="col-12">
            <section className="bg-main-light py-12 px-6">
              <Slider {...settings}>
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="col-lg-4 col-md-4 col-12 p-4">
                    <div className="bg-white shadow-lg rounded-lg p-6 hover:shadow-2xl transition-shadow duration-300">
                      <p className="text-text-color font-barlow text-lg">
                        "{testimonial.message}"
                      </p>
                      <h4 className="mt-4 text-main-green font-bold text-lg">
                        {testimonial.name}
                      </h4>
                      <p className="text-sm text-accent-blue">
                        {testimonial.role}
                      </p>
                    </div>
                  </div>
                ))}
              </Slider>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestimonialSlider;
